import { get } from "@/api";
import { clone } from '@/utils/utils';
// import config from "../../global/config"
const state = {
  patient: {},
  isMyPatient: false,
  follow: {},
  recent: {},
};

const mutations = {
  setPatient (state, data) {
    state.patient = clone(data);
  },
  setIsMyPatient (state, data) {
    state.isMyPatient = data;
  },
  setFollow (state, data) {
    state.follow = clone(data);
  },
  setRecent (state, data) {
    state.recent = clone(data);
  },
};

const actions = {

};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}